import { render, staticRenderFns } from "./versements-aim.vue?vue&type=template&id=72299242"
import script from "./versements-aim.vue?vue&type=script&setup=true&lang=js"
export * from "./versements-aim.vue?vue&type=script&setup=true&lang=js"
import style0 from "./versements-aim.vue?vue&type=style&index=0&id=72299242&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports